import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import { Button, Input } from '../../components/Ui';
import { Reveal } from '../../components/Motion';
import api from '../../api/endpoints';
import { colors } from '../../theme';

/** Phone entry. The OTP itself is delivered over WhatsApp. */
const LoginPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const role = params.get('role') || 'user';
  const isPartner = role === 'partner';

  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const sendOtp = async (e) => {
    if (e) e.preventDefault();
    const clean = phone.replace(/\D/g, '').slice(-10);
    if (clean.length !== 10) { setError('Enter a valid 10 digit mobile number'); return; }
    setError('');
    setLoading(true);
    try {
      const res = await api.auth.sendOtp({ phone: clean, role });
      navigate('/verify', {
        state: {
          phone: clean,
          role,
          devOtp: res.data && res.data.otp,
          devMode: res.data && res.data.devMode,
          isRegistered: res.data && res.data.isRegistered,
        },
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column' }}>
      <div style={{ maxWidth: 460, width: '100%', margin: '0 auto', padding: 22, flex: 1 }}>
        <button
          type="button"
          className="press"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          style={{
            width: 36, height: 36, borderRadius: 12, background: colors.bg,
            border: 0, fontSize: 18, marginBottom: 20,
          }}
        >
          ‹
        </button>

        <Reveal>
          <Logo size={74} />
          <h1 className="h1" style={{ marginTop: 20 }}>
            {isPartner ? 'Partner login' : 'Welcome back'}
          </h1>
          <p className="t-body" style={{ color: colors.muted, marginTop: 8, lineHeight: 1.55 }}>
            {isPartner
              ? 'Sign in to manage your business, orders and bookings.'
              : 'Enter your mobile number to continue. We will send an OTP on WhatsApp.'}
          </p>
        </Reveal>

        <Reveal delay={120}>
          <form onSubmit={sendOtp} style={{ marginTop: 28 }}>
            <Input
              label="Mobile number"
              icon="🇮🇳"
              placeholder="10 digit mobile number"
              inputMode="numeric"
              autoComplete="tel-national"
              maxLength={10}
              value={phone}
              onChange={(e) => { setPhone(e.target.value.replace(/\D/g, '')); setError(''); }}
              error={error}
            />

            <div
              className="row"
              style={{ background: colors.successBg, padding: 12, borderRadius: 12, gap: 8 }}
            >
              <span style={{ fontSize: 16 }}>💬</span>
              <span className="t-small" style={{ color: '#15803D' }}>
                Your OTP arrives on WhatsApp at this number.
              </span>
            </div>

            <Button
              title="Send OTP"
              type="submit"
              loading={loading}
              size="lg"
              full
              style={{ marginTop: 16 }}
            />
          </form>
        </Reveal>

        <p className="t-tiny" style={{ textAlign: 'center', marginTop: 20, lineHeight: 1.5 }}>
          By continuing you agree to KAAMWALA&apos;s Terms of Service and Privacy Policy.
        </p>
      </div>

      <div style={{ textAlign: 'center', padding: '20px 22px 34px' }}>
        <Link to={`/login?role=${isPartner ? 'user' : 'partner'}`} className="t-small">
          {isPartner ? 'Looking for a service instead? ' : 'Want to offer your service? '}
          <span style={{ color: colors.primary, fontWeight: 800 }}>
            {isPartner ? 'Customer login' : 'Join as Partner'}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
